/**
 * Disables Zod's JIT compilation, which uses `new Function()` and causes
 * `unsafe-eval` CSP violations in production.
 *
 * This configuration must run before any modules that create or use Zod schemas.
 *
 * Context: https://github.com/colinhacks/zod/issues/5789
 */

import { config } from 'zod';
if (typeof config === 'function') {
  config({ jitless: true });
}
